// src/pages/OldProfile.jsx
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { useEffect, useMemo, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";

// Podglądy HTML na ekran:
import JoinDecision from "./decision";
import Contract from "./contract";
import AdultContract from "./adultContract";
import ParentStatement from "./parentStatement";
import RulesStatement from "./rulesStatement";
import JoinRequest from "./joinRequest";

// >>> WERSJE PDF (czyste <Document/>):
import AdultContractDoc from "./adultContractDoc"
import ContractDoc from "./contractDoc";                  // zrefaktoruj analogicznie
import ParentStatementDoc from "./parentStatementDoc";    //   -||-
import RulesStatementDoc from "./rulesStatementDoc";      //   -||-
import JoinDecisionDoc from "./decisionDoc";              //   -||-
import JoinRequestDoc from "./joinRequestDoc";                        //   -||-

import { pdf } from "@react-pdf/renderer";

export default function OldProfile() {
  const params = useParams();

  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [zipping, setZipping] = useState(false);

  // ---- helpery ----
  const dotToISO = (s) => {
    const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec((s || "").trim());
    if (!m) return null;
    const [, dd, mm, yyyy] = m;
    return `${yyyy}-${mm}-${dd}`;
  };
  const fmtDate = (isoLike) => {
    if (!isoLike) return "";
    try {
      const asISO = isoLike.includes(".") ? dotToISO(isoLike) : isoLike;
      return asISO ? new Date(asISO).toLocaleDateString("pl-PL") : isoLike;
    } catch {
      return String(isoLike);
    }
  };
const sanitize = (s) =>
  (s || "Uczestnik").replace(/[<>:"/\\|?*\x00-\x1F]/g, "_").trim();

  // ---- pobieranie starych users ----
  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "users"),
      (snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data());
        const clients = [];
        for (let i = 0; i < data.length; i++) {
          const suArr = Array.isArray(data[i]?.subUsers)
            ? data[i].subUsers
            : Object.values(data[i]?.subUsers || {});
          for (const v of suArr) clients.push({ uid: data[i]?.uid, acc: data[i], user: v });
        }
        setUsers(clients);
        setLoadingUsers(false);
      },
      (err) => {
        console.error("Błąd pobierania users:", err);
        setUsers([]);
        setLoadingUsers(false);
      }
    );
    return () => unsub();
  }, []);

  const subusersOfParent = useMemo(() => {
    if (!params?.uid) return [];
    return (users || []).filter((x) => x?.uid === params.uid);
  }, [users, params?.uid]);

  const accountDoc = subusersOfParent?.[0]?.acc;
  const accountSign =
    accountDoc?.sign || accountDoc?.parent?.sign || accountDoc?.parent?.signUrl || null;
  const accountDate = accountDoc?.date || "";

  const buildDocsForOld = (user) => {
    const base = { ...(user?.docs || {}) };
    if (!accountSign) return base;

    const accDateISO = dotToISO(accountDate || "") || accountDate || "";
    base.contract = { ...(base.contract || {}), sign: base.contract?.sign || accountSign, date: base.contract?.date || accDateISO || "", signed: true };
    base.rules = { ...(base.rules || {}), sign: base.rules?.sign || accountSign, date: base.rules?.date || accDateISO || "", signed: true };
    base.parentStatement = { ...(base.parentStatement || {}), sign: base.parentStatement?.sign || accountSign, date: base.parentStatement?.date || accDateISO || "", signed: true };
    return base;
  };

  // zlecenia PDF do ZIP dla jednego subUsera:
  const buildPdfJobsForUser = (user, docs) => {
    if (!accountSign) return [];
    const date = docs?.contract?.date || accountDate;
    const signing = docs?.contract?.sign || accountSign;

    const jobs = [
      {
        label: "Wniosek o dołączenie",
        date,
        node: <JoinDecisionDoc displayName={user?.displayName} date={fmtDate(date)} signing={signing} />,
      },
      {
        label: "Wniosek – zgłoszenie",
        date,
        node: <JoinRequestDoc displayName={user?.displayName} date={fmtDate(date)} signing={signing} />,
      },
    ];

    if (!user?.adult) {
      jobs.push({
        label: "Umowa",
        date,
        node: (
          <ContractDoc
            user={user}
            parent={accountDoc?.parent}
            acc={accountDoc}
            date={fmtDate(date)}
            signing={signing}
          />
        ),
      });
      jobs.push({
        label: "Oświadczenie rodzica",
        date,
        node: (
          <ParentStatementDoc
            user={user}
            parent={accountDoc?.parent}
            acc={accountDoc}
            signing={docs?.parentStatement?.sign || signing}
            date={fmtDate(docs?.parentStatement?.date || date)}
          />
        ),
      });
    } else {
      jobs.push({
        label: "Umowa (dorosły)",
        date,
        node: (
          <AdultContractDoc
            user={user}
            acc={accountDoc}
            parent={accountDoc?.parent}
            date={fmtDate(docs?.adultContract?.date || date)}
            signing={docs?.adultContract?.sign || signing}
          />
        ),
      });
    }

    if (accountDoc?.facility_id !== "cfh66CW4jxFRMkU9AT5y") {
      jobs.push({
        label: "Oświadczenie – regulamin",
        date,
        node: (
          <RulesStatementDoc
            displayName={user?.displayName}
            facility={accountDoc?.facility_id}
            signing={docs?.rules?.sign || signing}
            date={fmtDate(docs?.rules?.date || date)}
          />
        ),
      });
    }

    return jobs;
  };



const handleDownloadZipFor = async (participant) => {
  if (!accountSign) {
    alert("Brak podpisu na profilu – brak dokumentów do pobrania.");
    return;
  }
  try {
    setZipping(true);

    // lazy imports
    const jszipMod = await import("jszip");
    const JSZip = jszipMod.default || jszipMod;
    const fsMod = await import("file-saver");
    const saveAs = fsMod.saveAs || fsMod.default;

    const zip = new JSZip();
    let total = 0;

    // zbuduj docs i joby PDF dla JEDNEGO uczestnika
    const docs = buildDocsForOld(participant);
    const jobs = buildPdfJobsForUser(participant, docs); // <- Twoja funkcja z poprzedniej wersji

    for (const job of jobs) {
      try {
        const blob = await pdf(job.node).toBlob();
        const dateISO =
          (job.date && (job.date.includes(".") ? dotToISO(job.date) : job.date)) || "";
        const suffix = dateISO ? `_${dateISO.slice(0, 10)}` : "";
        // pliki trafiają BEZPOŚREDNIO do ROOT archiwum (bez podfolderu!)
        zip.file(`${sanitize(job.label)}${suffix}.pdf`, blob);
        total++;
      } catch (e) {
        console.warn("Pominięto dokument (render PDF):", job.label, e);
      }
    }

    if (total === 0) {
      alert("Brak dokumentów do pobrania dla tego uczestnika.");
      return;
    }

    // NAZWA ARCHIWUM = nazwa uczestnika, bez „_dokumenty” i bez zagnieżdżania
    const participantName = sanitize(participant?.displayName || "Uczestnik");
    const archive = await zip.generateAsync({ type: "blob" });
    saveAs(archive, `${participantName}.zip`);
  } catch (e) {
    console.error("ZIP error:", e);
    alert("Nie udało się utworzyć archiwum ZIP.");
  } finally {
    setZipping(false);
  }
};


  // ---- RENDER ----
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24, width: "min(1000px, 92%)", margin: "20px auto 40px" }}>
      <div style={{ width: "100%" }}>
        <h2 style={{ margin: 0, fontSize: 20, color: "#111" }}>Profil konta</h2>
        <div style={{ color: "#555", fontSize: 13, marginTop: 4 }}>
          UID: {params?.uid}
          {accountDoc?.email ? ` • ${accountDoc?.email}` : ""}
        </div>
      </div>

      {!loadingUsers && (
        <div style={{ width: "100%", border: "1px solid rgba(0,0,0,.12)", borderRadius: 10, padding: 12, background: "#fff", fontSize: 13 }}>
          <div style={{ marginBottom: 6, fontWeight: 700 }}>Status podpisu</div>
          {accountSign ? (
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div>Podpis na profilu rodzica: <b>TAK</b></div>
              {accountDate ? <div>• Data złożenia: <b>{fmtDate(accountDate)}</b></div> : null}
              <img
                src={accountSign}
                alt="Podpis"
                style={{ marginLeft: "auto", maxWidth: 220, maxHeight: 80, objectFit: "contain", border: "1px dashed rgba(0,0,0,.15)", background: "rgba(0,0,0,.02)", borderRadius: 6, padding: 4 }}
              />
            </div>
          ) : (
            <div style={{ color: "#991b1b" }}>Brak podpisu w profilu rodzica — dokumenty nie są dostępne.</div>
          )}
        </div>
      )}

     {/* LISTA SUBUSERÓW + DOKUMENTY */}
<div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 12 }}>
  <h3 style={{ margin: 0, fontSize: 16, color: "#111" }}>
    Uczestnicy (subUserzy)
  </h3>

  {loadingUsers && <div style={{ fontSize: 13 }}>Wczytywanie…</div>}

  {!loadingUsers && subusersOfParent.length === 0 && (
    <div style={{ fontSize: 13, color: "#666" }}>
      Brak uczestników dla tego konta.
    </div>
  )}

  {!loadingUsers &&
    subusersOfParent.map(({ user: participant }, idx) => {
      const docs = buildDocsForOld(participant);

      return (
        <div
          key={participant?.index || idx}
          style={{
            border: "1px solid rgba(0,0,0,.12)",
            borderRadius: 10,
            padding: 12,
            background: "#fff",
          }}
        >
          {/* Nagłówek karty uczestnika */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
              gap: 8,
              flexWrap: "wrap",
            }}
          >
            <div style={{ fontSize: 15, fontWeight: 800 }}>
              {participant?.displayName || "—"}
            </div>
            <div style={{ fontSize: 12, color: "#555" }}>
              PESEL: {participant?.pesel || "—"} • Data ur.: {participant?.dateOfBirth || "—"}
            </div>
          </div>

          {/* Przyciski akcji */}
          <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
            <button
              onClick={() => handleDownloadZipFor(participant)}
              disabled={zipping || !accountSign}
              style={{
                height: 32,
                padding: "0 10px",
                fontSize: 12,
                borderRadius: 6,
                border: "1px solid #0045C7",
                background: !accountSign ? "#9ca3af" : "#0045C7",
                color: "#fff",
                cursor: zipping || !accountSign ? "not-allowed" : "pointer",
              }}
              title={
                accountSign
                  ? "Pobierz wszystkie dokumenty uczestnika (ZIP)"
                  : "Brak podpisu na profilu – nie można pobrać dokumentów"
              }
            >
              {zipping ? "Przygotowuję ZIP…" : "Pobierz dokumenty (ZIP)"}
            </button>

            {/* Kopiuj: Imię i nazwisko – telefon – UID */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 18,
                width: 18,
                borderRadius: 5,
                backgroundColor: "rgb(0,0,0,0)",
                padding: 4,
                border: "2px solid #0045C7",
                transition: "0.6s",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e?.stopPropagation();
                const el = document.createElement("textarea");
                el.value =
                  (participant?.displayName || "") +
                  " - " +
                  (accountDoc?.parent?.phone || accountDoc?.phone || "") +
                  " - " +
                  (accountDoc?.uid || "");
                el.setAttribute("readonly", "");
                el.style.position = "absolute";
                el.style.left = "-9999px";
                document.body.appendChild(el);
                el.select();
                el.focus();
                document.execCommand("copy");
                document.body.removeChild(el);
              }}
              title="Kopiuj: Imię i nazwisko – telefon – UID"
            >
              <img
                src={process.env.PUBLIC_URL + "/clipboard.png"}
                style={{ width: 25 }}
                alt=""
              />
            </div>
          </div>

          {/* Podglądy dokumentów – tylko jeśli jest podpis na profilu */}
          {!accountSign ? (
            <div style={{ marginTop: 8, fontSize: 12, color: "#666" }}>
              Aby wyświetlić dokumenty dla uczestnika, najpierw dodaj podpis na profilu rodzica.
            </div>
          ) : (
            <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 12 }}>
              {/* Wniosek/Decyzja – opcjonalnie */}
              <JoinDecision
                displayName={participant?.displayName}
                date={fmtDate(docs?.contract?.date || accountDoc?.date)}
                signing={docs?.contract?.sign || accountSign}
              />

              {/* Wniosek o dołączenie (jeśli używasz) */}
              {/* <JoinRequest
                displayName={participant?.displayName}
                date={fmtDate(docs?.contract?.date || accountDoc?.date)}
                signing={docs?.contract?.sign || accountSign}
              /> */}

              {/* Umowa dla dziecka */}
              {!participant?.adult && (
                <Contract
                  user={participant}
                  parent={accountDoc?.parent}
                  acc={accountDoc}
                  date={fmtDate(docs?.contract?.date || accountDoc?.date)}
                  signing={docs?.contract?.sign || accountSign}
                />
              )}

              {/* Umowa dla dorosłego */}
              {participant?.adult && (
                <AdultContract
                  user={participant}
                  acc={accountDoc}
                  parent={accountDoc?.parent}
                  date={fmtDate(docs?.adultContract?.date || accountDoc?.date)}
                  signing={docs?.adultContract?.sign || accountSign}
                />
              )}

              {/* Oświadczenie rodzica */}
              {!participant?.adult && (
                <ParentStatement
                  user={participant}
                  parent={accountDoc?.parent}
                  acc={accountDoc}
                  signing={docs?.parentStatement?.sign || accountSign}
                  date={fmtDate(docs?.parentStatement?.date || accountDoc?.date)}
                />
              )}

              {/* Regulamin (warunek jak wcześniej) */}
              {accountDoc?.facility_id !== "cfh66CW4jxFRMkU9AT5y" && (
                <RulesStatement
                  displayName={participant?.displayName}
                  facility={accountDoc?.facility_id}
                  signing={docs?.rules?.sign || accountSign}
                  date={fmtDate(docs?.rules?.date || accountDoc?.date)}
                />
              )}
            </div>
          )}
        </div>
      );
    })}
</div>

    </div>
  );
}
